/* src/app/core/modules/shared/components/dynamic-form-card/dynamic-form-card.component.scss */
/*# sourceMappingURL=/avvera/dev/dynamic-form-card.component.css.map */
